<script>
  // See figma:
  // https://www.figma.com/design/q9qWRCxrMdp2ohFqGmbxdk/Icons?node-id=8-1401&node-type=frame&t=R5egu04miZ93pfqr-0
  // for icon set
  export let size = '16';
  export let color = '#1A1A1A';
  export let style = '';
  export let path;
  export let fill = 'none';
</script>

<style>
  .icon {
    display: inline-block;
    line-height: 0;
  }
</style>

<div class="icon" aria-hidden="true" style="width: {size}px; height: {size}px; color: {color}; {style}">
  <svg viewBox="0 0 24 24" width={size} height={size} fill={fill} xmlns="http://www.w3.org/2000/svg">
    {@html path}
  </svg>
</div>
